import React from "react";
import { Route, Routes } from "react-router-dom";
import CreateAccount from "./components/LogInPages/CreateAccount";
import Login from "./components/LogInPages/Login";
import SignUpWithEmail from "./components/LogInPages/SignUpWithEmail";
import Blog from "./components/pages/Blog/Blog";
import About from "./components/pages/Company/About";
import Contact from "./components/pages/Contact.js/Contact";
import FAQs from "./components/pages/FAQ/FAQs";
import Home from "./components/pages/Home/Home";
import Header from "./components/shared/Header";

const Main = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/question" element={<FAQs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/create" element={<CreateAccount />} />
        <Route path="/signupemail" element={<SignUpWithEmail />} />
      </Routes>
    </div>
  );
};

export default Main;
